<template>
  <div>
    <h4 class="font-italic">
      please select a power to perform a toric calculation
    </h4>
    <v-col sm="12" md="12" lg="12">
      <v-data-table
        v-model="fields.selected"
        single-select
        :headers="fields.headers"
        :items="fields.powers"
        :items-per-page="5"
        item-key="name"
        hide-default-footer
        sort-by="id"
        disable-sort
        mobile-breakpoint="300"
        class="iol-v2-results"
        :item-class="itemRowBackground"
        @click:row="handleClick"
      ></v-data-table>
    </v-col>
  </div>
</template>

<style>
.iol-v2-results.v-data-table {
  border: 1px solid #000 !important;
  border-radius: 3px !important;
  background-color: inherit !important;
  text-align: center !important;
}
.iol-v2-results.v-data-table td {
  text-align: center !important;
}
.iol-v2-results.v-data-table thead tr th {
  background-color: #c4c4c4 !important;
  color: #000 !important;
  font-size: 18px !important;
  font-style: bold !important;
  text-align: center !important;
}
.iol-v2-results.v-data-table tr > td:first-child {
  border-right: 1px solid #000 !important;
}
.iol-v2-results.v-data-table th:first-child {
  border-right: 1px solid #000 !important;
}
.iol-v2-results.v-data-table tfoot tr td {
  background-color: #c4c4c4 !important;
  color: #000 !important;
  font-size: 18px !important;
  font-style: bold !important;
  text-align: center !important;
}
.iol-v2-results.v-data-table tfoot tr > td:first-child {
  border-right: 0px solid #000 !important;
}
.iol-v2-results.v-data-table tr:hover {
  background-color: #9cccf0 !important;
}
.selected {
  background-color: #9cccf0 !important;
}
</style>

<script>
export default {
  name: 'iol-data-table-power',
  props: ['fields'],
  data() {
    return {
      field: this.fields,
      loading: true,
    }
  },
  methods: {
    handleClick(item) {
      let id = item.id
      if (this.fields.selected.includes(id)) {
        this.fields.selected.pop()
        this.fields.selected_power = null
        this.fields.selected_es = null
      } else {
        this.fields.selected.splice(0, 1, id)
        this.fields.selected_power = this.fields.powers[this.fields.selected][
          'power'
        ]
        this.fields.selected_es = this.fields.powers[this.fields.selected]['es']
      }
    },
    itemRowBackground(item) {
      return this.fields.selected.includes(item.id) ? 'selected' : ''
    },
  },
  created() {
    this.$emit('fields', this.field)
  },
  mounted() {
    // :loading="this.loading"
    // loading-text="Loading... Please wait"
    // setTimeout(() => {
    //   this.loading = false
    // }, 2000)
  },
}
</script>
